module.exports = __webpack_public_path__ + "media/images/app/visitors/bridal/diamond_necklace-9b987bc6df4cb7b2c928549ce252f142.webp";